export default {
    url: '/needs?courseId',
    template: '<planning-needs classifiers="vm.classifiers" employees="vm.employees" sites="vm.sites"/>',
    resolve: {
        classifiers (ClassifierResource) {
            return ClassifierResource.query({ pageSize: 0, expand: 'activeI18n' }).$promise;
        },
        sites (SiteResource) {
            return SiteResource.query({ pageSize: 0, planningSites: true }).$promise;
        }
    },
    controller (lodash, classifiers, sites, CLASSIFIER_ENUM) {
        this.classifiers = classifiers;
        this.sites = sites;
        lodash.forEach(this.classifiers, classifier => {
            if (classifier.type === CLASSIFIER_ENUM.KEYS.FIELD) {
                classifier.activeI18nValue = classifier.activeI18n.value;
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/planning/needs/index.js